// Popula a seção
function populateDestaques($parent, section, action = 'insert') {
  if ($parent.length > 0 && section) {
    // Atualiza a seção (Remove antes para ser criada novamente)
    if (action === 'update') {
      const $sectionUpd = $('#' + section.id);
      if ($sectionUpd.length > 0) {
        $sectionUpd.html('');
        $sectionUpd.remove();
      }
    }

    // Exibe seção
    const showSection = section['show'];
    const showSectionClass = !showSection ? 'd-none' : '';

    // Itens
    let itensHTML = `<div class="carousel carousel-blocos"></div>`;
    let $itens = $(itensHTML);
    if (section['lista'] && section['lista'].length > 0) {
      section['lista'].forEach((item) => {
        let $figure = '';
        if (item['media_type'] == 'icon') {
          $figure = `<figure class="img bloco-foto bloco-icon" style="--icon-size: ${
            item['icon_size']
          }px; --icon-color: ${item['icon_color']}">${getSvgIcon(item['icon'])}</figure>`;
        } else {
          $figure = `<figure class="img bloco-foto">
            <img src="${item['img']}" alt="${item['alt']}" width="45px" height="45px">
          </figure>`;
        }
        // HTML do item
        let itemHTML = `
        <div class="carousel-item bloco-wrapper" data-aos="fade-up" data-aos-offset="0">
          <div class="bloco">
            ${$figure}
            <div class="bloco-infos">
              <div class="bloco-titulo md-text">${mdParse(item['titulo'], true)}</div>
              <div class="bloco-texto md-text">${mdParse(item['texto'], true)}</div>
            </div>
          </div>
        </div>`;
        const $item = $(itemHTML);
        $itens.append($item);
      });
    }

    // Estrutura da seção
    let sectionHTML = `
    <section id="${section['id']}" data-sec-type="destaques" class="home-section blocos bg-image ${showSectionClass}">
      <div class="section-content">
        <div class="container">
          ${$itens[0].outerHTML}
        </div>
      </div>
    </section>`;

    // Cria o elemento
    let $section = $(sectionHTML);

    // Estilos
    if (Object.keys(section.styles).length > 0) {
      Object.keys(section.styles).forEach((styleVar) => {
        $section[0].style.setProperty('--' + styleVar, section.styles[styleVar]);
      });
    }

    // Ordem da seção
    $section[0].style.setProperty('--order', section['order']);
    $section[0].style.setProperty('order', section['order']);

    // Plano de fundo (Imagem)
    if (section['bg-type'] == 'image') {
      $section[0].style.setProperty('background-image', `url('${section['bg-image']}')`);
    }
    // Plano de fundo (Gradiente)
    else if (section['bg-type'] == 'gradient') {
      $section[0].style.setProperty('background-image', section['bg-gradient']);
    }

    $parent.append($section);

    // Plugins
    setTimeout(() => {
      blocosDestroySlick();
      blocosInitSlick();
    }, 100);
  }
}
